import { customAlphabet } from "nanoid";

const generateUuid = () => {
    const nanoid =
        customAlphabet("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", 21);

    return nanoid();
};

export default generateUuid;